import * as React from 'react';
import * as styles from './cookieLayer.scss';
import * as stylesGlobal from 'sass/styles/global.scss';
import { translate } from 'utils/translateUtil';
import { Button } from 'components/buttons/index';
import {setCookie} from 'utils/cookieUtils';
import { ROUTES } from 'constants/routes';


type Props = {

}

class
CookieLayer extends React.Component<Props, any> {
    constructor(props:Props) {
        super(props);
        this.state = {
            cookieLayerVisible: true
        }
    }

    public onCloseLayer = () => {
        const sessionObj = {'cookiesAccepted' : true};
        setCookie(sessionObj);
        this.setState({cookieLayerVisible: false});
    }

    public render() {

        return (
                <>
                {this.state.cookieLayerVisible &&
                <div className={styles.cookieLayerWrapper}>
                    <div className={stylesGlobal.clearfix}>
                        <div className={styles.textWrapper }>
                            <p>{translate('cookie-layer.copy')}
                                <a
                                    href={ROUTES.COOKIE_LINK}
                                    target={'_blank'}>{translate('cookie-layer.link')}</a>
                            </p>
                        </div>
                        <div className={styles.buttonWrapper }>
                            <Button clickHandler={this.onCloseLayer}>
                                {translate('cookie-layer.button')}
                            </Button>
                        </div>

                    </div>
                </div>
                    }
            </>
        )
    }
}

export default CookieLayer;